import React from 'react';

function LoadingPage() {
  return (
    <div style={{ width: '100%', height: '100vh', backgroundColor: '#ffffff' }}>
      <div
        style={{
          position: 'fixed',
          backgroundAttachment: 'fixed',
          top: '50%',
          left: '50%',
          zIndex: '20050',
          opacity: '0.8',
          transform: 'translate(-50%, -50%)',
        }}
      >
        <img
          src={'https://eis.bir.gov.ph/cdn/img/loading.gif'}
          alt='In progress'
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%,-50%)',
          }}
        />
      </div>
    </div>
  );
}

export default LoadingPage;
